module.exports = __webpack_public_path__ + "static/media/error_icon.2037d728.png";